import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var ScaleBalanced = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return /*#__PURE__*/React.createElement(StyledIconBase, _extends({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 640 512"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M384 32h128c17.7 0 32 14.3 32 32s-14.3 32-32 32H398.4c-5.2 25.8-22.9 47.1-46.4 57.3V448h160c17.7 0 32 14.3 32 32s-14.3 32-32 32H128c-17.7 0-32-14.3-32-32s14.3-32 32-32h160V153.3c-23.5-10.3-41.2-31.6-46.4-57.3H128c-17.7 0-32-14.3-32-32s14.3-32 32-32h128c14.6-19.4 37.8-32 64-32s49.4 12.6 64 32zM125.8 177.3 51.1 320h153.8l-74.7-142.7c-.4-.8-1.3-1.3-2.2-1.3s-1.7.5-2.2 1.3zM128 128c18.8 0 36 10.4 44.7 27l77.8 148.5c3.1 5.8 6.1 14 5.5 23.8-.7 12.1-4.8 35.2-24.8 55.1-20.3 20.2-53 33.6-103.2 33.6s-82.9-13.4-103.2-33.5c-20-20-24.2-43-24.8-55.1-.6-9.8 2.5-18 5.5-23.8L83.3 155c8.7-16.6 25.9-27 44.7-27zm384 48c-.9 0-1.7.5-2.2 1.3L435.1 320h153.8l-74.7-142.7c-.4-.8-1.3-1.3-2.2-1.3zm-44.7-21c8.7-16.6 25.9-27 44.7-27s36 10.4 44.7 27l77.8 148.5c3.1 5.8 6.1 14 5.5 23.8-.7 12.1-4.8 35.2-24.8 55.1-20.3 20.2-53 33.6-103.2 33.6s-82.9-13.4-103.2-33.5c-20-20-24.2-43-24.8-55.1-.6-9.8 2.5-18 5.5-23.8L467.3 155z"
  }));
});
ScaleBalanced.displayName = 'ScaleBalanced';
export var ScaleBalancedDimensions = {
  height: 512,
  width: 640
};